import { useState } from "react";
import { Copy } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { copyPicks } from "@/hooks/usePick";

export function useOtherLeagues() {
  const { leagues } = useAuth();
  return leagues.filter((l) => !l.archived && !l.suspended).length > 1;
}

export default function CopyPicksButton({ leagueId, gameIds, label, testId, className = "" }) {
  const [busy, setBusy] = useState(false);
  const many = useOtherLeagues();
  if (!many || !gameIds.length) return null;
  const go = async () => { setBusy(true); await copyPicks(leagueId, gameIds); setBusy(false); };
  return (
    <button onClick={go} disabled={busy} className={`mpl-btn-ghost text-xs ${className}`} data-testid={testId}>
      <Copy size={13} /> {busy ? "Copie…" : label}
    </button>
  );
}
